import { TestSuiteType } from "store/src/lib/tests/entity";
interface FieldDefaults {
    active: boolean;
    required: boolean;
  }

  interface SettingOverride {
    field_name: string;
    active?: boolean;
    required?: boolean;
  }
  
  export const translateFieldName = (originalFieldName: string): string => {
    switch (originalFieldName) {
      case 'building_id':
      case 'area_id':
      case 'level_id':
        return 'location'
      case 'images':
        return 'photographs'
      case 'result':
        return 'rating'
      default:
        return originalFieldName;
    }
  }
  
  export const getDefaultFieldSettings = (
    fieldName: string, 
    testSuiteType: TestSuiteType
  ): FieldDefaults => {
    const baseFields = {
      asset: { active: true, required: true },
      location: { active: true, required: true },
      element: { active: true, required: true },
      element_name: { active: true, required: true },
      element_id: { active: true, required: true }
    };
  
    const testSuiteSpecificFields: Record<TestSuiteType, Record<string, FieldDefaults>> = {
      compliance: {
        test: { active: true, required: true },
        observations: { active: true, required: true },
        recommendations: { active: true, required: true },
        photographs: { active: true, required: true },
        rating: { active: true, required: true }
      },
      condition: {
        rating: { active: true, required: true },
        observations: { active: true, required: true },
        recommendations: { active: true, required: true },
        photographs: { active: true, required: true }
      },
      generic: {
        photographs: { active: true, required: true },
        observations: { active: true, required: true },
        recommendations: { active: true, required: true },
        rating: { active: false, required: false }
      },
      numerical: {
        rating: { active: true, required: true },
        observations: { active: true, required: false },
        recommendations: { active: true, required: false },
        photographs: { active: true, required: false }
      }
    };
  
    return (
      baseFields[fieldName] || 
      testSuiteSpecificFields[testSuiteType]?.[fieldName] || 
      { active: true, required: false }
    );
  };

  export const getFieldSetting = (
    fieldName: string,
    testSuiteType: TestSuiteType,
    settings: SettingOverride[]
  ): FieldDefaults => {
    const translatedFieldName = translateFieldName(fieldName);
    const defaultSettings = getDefaultFieldSettings(translatedFieldName, testSuiteType);
    const settingOverride = settings.find((s) => s.field_name === translatedFieldName);
  
    return {
      active: settingOverride?.active ?? defaultSettings.active,
      required: settingOverride?.required ?? defaultSettings.required,
    };
  };
  
  